var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3548_6233)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8.37207,
    r: 8,
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.56934 11.5731V5.22491C5.56934 4.77802 6.05923 4.50408 6.43997 4.73808L11.8812 8.08218C12.2542 8.3114 12.2414 8.85768 11.8582 9.06927L6.41695 12.0733C6.0361 12.2836 5.56934 12.0081 5.56934 11.5731Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3548_6233"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none",
    transform: "translate(0 0.37207)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlay);
export default __webpack_public_path__ + "static/media/play.4dc0f418fba2d5f1cd8925f70090b52d.svg";
export { ForwardRef as ReactComponent };